/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2024-03-22 13:32:45
 */
/* eslint-disable */
import actionTypes from '../constants/actionTypes'
import exceptionHelper from '../utils/exceptionHelper'
import fetchHelper from '../utils/fetchHelper'
import * as SentryUtils from '../utils/sentryUtils'
import { setLoading } from './main'

// /**
//  * 非svip团队，查询今日额度
//  * @param {*} data
//  * @returns
//  */
// export function fetchTodayCut(data) {
//   return (dispatch, getState) => {
//     dispatch(setLoading(true))
//     let config = {
//       url: __API_SERVER_HOST__ + '/web/folder/photo/today/cut',
//       arguments: {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(data)
//       }
//     }
//     return fetchHelper(dispatch, getState, config)
//       .then((result) => exceptionHelper(result))
//       .then((data) => {
//         return Promise.resolve(data)
//       })
//       .catch((err) => {
//         SentryUtils.captureFetchException(err, config)
//         return Promise.reject(null)
//       })
//       .finally(() => {
//         dispatch(setLoading(false))
//       })
//   }
// }

export function uploadPhoto(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/photo/upload',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}
